import React from 'react';

const PatientTreatmentContext = React.createContext({
	patientId: '',
	caseId: undefined,
	isMyCase: undefined,
});

interface PatientTreatmentContextProviderProps {
	children: React.ReactElement | React.ReactElement[];
	patientId: string;
	caseId?: string;
	isMyCase?: boolean;
}

const PatientTreatmentContextProvider: React.FC<
	PatientTreatmentContextProviderProps
> = props => {
	const { children, patientId, caseId = null, isMyCase = false } = props;

	return (
		// @ts-ignore
		<PatientTreatmentContext.Provider value={{ patientId, caseId, isMyCase }}>
			{children}
		</PatientTreatmentContext.Provider>
	);
};

export const usePatientTreatmentContext = () =>
	React.useContext(PatientTreatmentContext);

export default PatientTreatmentContextProvider;
